import { render } from "./SocialRelief.vue?vue&type=template&id=6b93b422&ts=true"
import script from "./SocialRelief.vue?vue&type=script&lang=ts"
export * from "./SocialRelief.vue?vue&type=script&lang=ts"

import "./SocialRelief.vue?vue&type=style&index=0&id=6b93b422&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__